import React, { Fragment, useState, useEffect, useRef } from 'react';
import man from '../../assets/images/dashboard/profile.jpg'
import { FileText, LogIn, Mail, User, MessageSquare, Bell, Maximize, Search, ShoppingCart, Minus, Plus, X, Send, ArrowLeft, Clock } from 'react-feather';
import { useNavigate } from 'react-router-dom'
import { firebase_app } from '../../data/config'
import { useAuth0 } from '@auth0/auth0-react'
import Bookmark from "../../layout/bookmark"
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import { English, Deutsch, Español, Français, Português, 简体中文, Notification, DeliveryProcessing, OrderComplete, TicketsGenerated, DeliveryComplete, CheckAllNotification, ViewAll, MessageBox, EricaHughes, KoriThomas, Admin, Account, Inbox, Taskboard, LogOut, AinChavez, CheckOut, ShopingBag, OrderTotal, GoToyourcart } from '../../constant'
import { InputGroup, InputGroupText } from 'reactstrap';
import { classes } from '../../data/layouts';
import authAxios from "../../services/Token";

const Rightbar = () => {

  const history = useNavigate();
  const [profile, setProfile] = useState('');
  const [name, setName] = useState('')
  const [searchresponsive, setSearchresponsive] = useState(false)
  const [langdropdown, setLangdropdown] = useState(false)
  const [moonlight, setMoonlight] = useState(false)
  const [cartDropdown, setCartDropDown] = useState(false)
  const [notificationDropDown, setNotificationDropDown] = useState(false)
  const [chatDropDown, setChatDropDown] = useState(false)
  const { i18n } = useTranslation();
  const [selected, setSelected] = useState('en');
  const [Administrador, setAdministrador] = useState('en');
  
  // Estados para el chat
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [unreadCount, setUnreadCount] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [autoScroll, setAutoScroll] = useState(true);
  const [userConversations, setUserConversations] = useState({});
  const [isViewingHistory, setIsViewingHistory] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  
  // Nuevos estados para notificaciones mejoradas
  const [unreadByUser, setUnreadByUser] = useState({});
  const [totalUnread, setTotalUnread] = useState(0);
  const [usersWithUnread, setUsersWithUnread] = useState([]);

  // Refs
  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const chatBodyRef = useRef(null);
  const scrollBlockedRef = useRef(false);

  // Función para obtener el ID del usuario
  const getUserId = () => {
    let ide = localStorage.getItem('idusuario');
    if (!ide) {
      ide = sessionStorage.getItem('idusuario');
    }
    return ide;
  };

  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
    setSelected(lng);
  };

  const { logout } = useAuth0()
  const authenticated = JSON.parse(localStorage.getItem("authenticated"));
  const auth0_profile = JSON.parse(localStorage.getItem("auth0_profile"))

  // Filtrar usuarios basado en el término de búsqueda
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter(user => 
        user.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.cargo.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredUsers(filtered);
    }
  }, [searchTerm, users]);

  // Scroll al final de los mensajes de forma inteligente
  const scrollToBottom = (force = false) => {
    if ((!autoScroll && !force) || scrollBlockedRef.current) return;
    
    setTimeout(() => {
      if (messagesContainerRef.current && !scrollBlockedRef.current) {
        messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
      }
    }, 100);
  };

  // Detectar si el usuario está scrolleando manualmente
  const handleScroll = () => {
    if (messagesContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = messagesContainerRef.current;
      const isAtBottom = scrollHeight - scrollTop - clientHeight < 50;
      setAutoScroll(isAtBottom);
      
      // Detectar si el usuario está viendo el historial (no está en la parte inferior)
      if (!isAtBottom) {
        setIsViewingHistory(true);
        scrollBlockedRef.current = true;
      } else {
        setIsViewingHistory(false);
        scrollBlockedRef.current = false;
      }
      
      setScrollPosition(scrollTop);
    }
  };

  // Restaurar posición del scroll después de actualizar mensajes si estaba viendo historial
  const restoreScrollPosition = () => {
    if (messagesContainerRef.current && scrollBlockedRef.current) {
      setTimeout(() => {
        messagesContainerRef.current.scrollTop = scrollPosition;
      }, 50);
    }
  };

  useEffect(() => {
    if (!isViewingHistory) {
      scrollToBottom(true);
    }
  }, [messages, selectedUser]);

  useEffect(() => {
    setProfile(localStorage.getItem('profileURL') || man);
    setName(localStorage.getItem('Name'))
    setAdministrador(localStorage.getItem('admin'))
    
    if (localStorage.getItem("layout_version") === "dark-only") {
      setMoonlight(true);
      document.body.classList.add("dark-only");
    }
    i18n.changeLanguage('en');
    
    // Cargar datos del chat si el usuario está autenticado
    if (localStorage.getItem('token')) {
      loadChatUsers();
      loadUnreadByUser();
      //loadUserConversations();
      
      // Polling para nuevos mensajes cada 3 segundos
      const interval = setInterval(() => {
        //loadUnreadByUser();
        //loadUserConversations();
        if (selectedUser) {
          //loadMessages(selectedUser.id, true);
        }
      }, 3000);
      
      return () => clearInterval(interval);
    }
  }, [selectedUser]);

  // Cargar usuarios para el chat
  const loadChatUsers = () => {
    const ide = getUserId();
    if (!ide) return;
    
    setLoading(true);
    authAxios.get("chat/users")
      .then((response) => {
        if (response.data.success) {
          setUsers(response.data.data);
          setFilteredUsers(response.data.data);
        }
      })
      .catch((error) => {
        console.error('Error loading chat users:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Cargar mensajes no leídos por usuario
  const loadUnreadByUser = () => {
    const ide = getUserId();
    if (!ide) return;
    
    authAxios.get("chat/unread-by-user")
      .then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          setTotalUnread(data.total_unread);
          setUsersWithUnread(data.users_with_unread);
          
          // Crear un mapa de conteo por usuario
          const unreadMap = {};
          data.users_with_unread.forEach(user => {
            unreadMap[user.id] = user.unread_count;
          });
          setUnreadByUser(unreadMap);
        }
      })
      .catch((error) => {
        console.error('Error loading unread by user:', error);
      });
  };

  // Cargar últimas conversaciones con cada usuario
  const loadUserConversations = () => {
    const ide = getUserId();
    if (!ide) return;
    
    authAxios.get("chat/conversations")
      .then((response) => {
        if (response.data.success) {
          setUserConversations(response.data.data);
        }
      })
      .catch((error) => {
        console.error('Error loading conversations:', error);
      });
  };

  // Cargar conteo de mensajes no leídos
  const loadUnreadCount = () => {
    const ide = getUserId();
    if (!ide) return;
    
    authAxios.get("chat/unread-count")
      .then((response) => {
        if (response.data.success) {
          setUnreadCount(response.data.count);
        }
      })
      .catch((error) => {
        console.error('Error loading unread count:', error);
      });
  };

  // Cargar mensajes con un usuario específico
  const loadMessages = (userId, isPolling = false) => {
    const ide = getUserId();
    if (!ide) return;
    
    if (!isPolling) {
      setLoading(true);
      setIsViewingHistory(false);
      scrollBlockedRef.current = false;
    }
    
    authAxios.get(`chat/messages/${userId}`)
      .then((response) => {
        if (response.data.success) {
          const newMessages = response.data.data;
          setMessages(newMessages);
          if (!selectedUser || selectedUser.id !== userId) {
            setSelectedUser(users.find(user => user.id === userId));
          }
          
          // Actualizar conteo local - resetear los no leídos de este usuario
          setUnreadByUser(prev => ({
            ...prev,
            [userId]: 0
          }));
          
          // Recalcular total
          const newTotal = totalUnread - (unreadByUser[userId] || 0);
          setTotalUnread(Math.max(0, newTotal));
          
          // Si es polling y hay nuevos mensajes, restaurar posición si estaba viendo historial
          if (isPolling && newMessages.length > messages.length) {
            if (scrollBlockedRef.current) {
              restoreScrollPosition();
            } else {
              scrollToBottom();
            }
          }
        }
      })
      .catch((error) => {
        console.error('Error loading messages:', error);
      })
      .finally(() => {
        if (!isPolling) {
          setLoading(false);
        }
      });
  };

  // Enviar mensaje
  const sendMessage = () => {
    if (!newMessage.trim() || !selectedUser) return;

    const ide = getUserId();
    if (!ide) return;
    
    // Optimistic update - agregar mensaje inmediatamente
    const tempMessage = {
      id: Date.now(), // ID temporal
      usuario_id: parseInt(ide),
      Receptor: selectedUser.id,
      descripcion: newMessage,
      fecha_registro: new Date().toISOString(),
      estado: 0,
      usuario: { nombre: name || 'Tú' }
    };
    
    setMessages(prev => [...prev, tempMessage]);
    setNewMessage('');
    setIsViewingHistory(false);
    scrollBlockedRef.current = false;
    setAutoScroll(true); // Forzar scroll al enviar mensaje
    
    authAxios.post("chat/send", {
      receptor_id: selectedUser.id,
      mensaje: newMessage
    })
      .then((response) => {
        if (response.data.success) {
          // Recargar mensajes para obtener el ID real
          loadMessages(selectedUser.id);
          loadUnreadByUser();
          loadUserConversations();
          
          // Mostrar notificación de éxito
          if (window.showNotification) {
            window.showNotification('success', 'Mensaje enviado', `Mensaje enviado a ${selectedUser.nombre}`);
          }
        }
      })
      .catch((error) => {
        console.error('Error sending message:', error);
        // Remover mensaje temporal si falla
        setMessages(prev => prev.filter(msg => msg.id !== tempMessage.id));
        if (window.showNotification) {
          window.showNotification('error', 'Error', 'No se pudo enviar el mensaje');
        }
      });
  };

  // Volver a la lista de usuarios
  const backToUserList = () => {
    setSelectedUser(null);
    setMessages([]);
    setSearchTerm('');
    setIsViewingHistory(false);
    scrollBlockedRef.current = false;
    setAutoScroll(true);
  };

  // Abrir chat con usuario
  const openChat = (userId) => {
    setSelectedUser(null);
    setMessages([]);
    setIsViewingHistory(false);
    scrollBlockedRef.current = false;
    setAutoScroll(true);
    setTimeout(() => {
      //loadMessages(userId);
    }, 100);
  };

  // Formatear fecha y hora del mensaje
  const formatMessageDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    
    if (isToday) {
      return `Hoy ${date.toLocaleTimeString('es-ES', { 
        hour: '2-digit', 
        minute: '2-digit' 
      })}`;
    } else {
      return `${date.toLocaleDateString('es-ES')} ${date.toLocaleTimeString('es-ES', { 
        hour: '2-digit', 
        minute: '2-digit' 
      })}`;
    }
  };

  // Formatear hora del último mensaje (solo hora)
  const formatLastMessageTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString('es-ES', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  // Obtener último mensaje de la conversación con un usuario
  const getLastMessageForUser = (userId) => {
    const conversation = userConversations[userId];
    if (conversation && conversation.length > 0) {
      return conversation[0];
    }
    return null;
  };

  // Verificar si hay mensajes no leídos con un usuario
  const hasUnreadMessages = (userId) => {
    return unreadByUser[userId] > 0;
  };

  // Obtener el texto del preview del último mensaje
  const getLastMessagePreview = (lastMessage) => {
    if (!lastMessage) return 'No hay mensajes';
    
    const currentUserId = parseInt(getUserId());
    const isFromCurrentUser = lastMessage.usuario_id === currentUserId;
    
    if (isFromCurrentUser) {
      return `Tú: ${lastMessage.descripcion}`;
    } else {
      const senderName = lastMessage.usuario?.nombre || 'Usuario';
      return `${senderName}: ${lastMessage.descripcion}`;
    }
  };

  // Limpiar búsqueda
  const clearSearch = () => {
    setSearchTerm('');
  };

  const Logout_From_Firebase = () => {
    localStorage.removeItem('profileURL')
    localStorage.removeItem('token');
    localStorage.setItem("rol", null)
    firebase_app.auth().signOut()
    history(`${process.env.PUBLIC_URL}/login`)
  }

  const Logout_From_Auth0 = () => {
    localStorage.removeItem("auth0_profile")
    localStorage.setItem("authenticated", false)
    localStorage.setItem("rol", null)
    history(`${process.env.PUBLIC_URL}/login`)
    logout()
  }

  const defaultLayoutObj = classes.find(item => Object.values(item).pop(1) === 'compact-wrapper');
  const layout = localStorage.getItem('layout') || Object.keys(defaultLayoutObj).pop();
  
  const RedirectToChats = () => {
    history(`${process.env.PUBLIC_URL}/app/users/userProfile/${layout}`)
  }
  
  const RedirectToChat = () => {
    history(`${process.env.PUBLIC_URL}/app/chat-app/${layout}`)
  }

  const UserMenuRedirect = (redirect) => {
    history(redirect)
  }

  //full screen function
  function goFull() {
    if ((document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  const SeacrhResposive = (searchresponsive) => {
    if (searchresponsive) {
      setSearchresponsive(!searchresponsive)
      document.querySelector(".search-full").classList.add("open");
      document.querySelector(".more_lang").classList.remove("active");
    } else {
      setSearchresponsive(!searchresponsive)
      document.querySelector(".search-full").classList.remove("open");
    }
  }

  const LanguageSelection = (language) => {
    if (language) {
      setLangdropdown(!language)
    } else {
      setLangdropdown(!language)
    }
  }

  const MoonlightToggle = (light) => {
    if (light) {
      setMoonlight(!light)
      document.body.classList.add("light");
      document.body.classList.remove("dark-only");
      localStorage.setItem('layout_version', 'light');
    } else {
      setMoonlight(!light)
      document.body.classList.remove("light");
      document.body.classList.add("dark-only");
      localStorage.setItem('layout_version', 'dark-only');
    }
  }

  // Estilos CSS integrados
  const chatStyles = {
    chatDropdown: {
      position: 'absolute',
      top: '100%',
      right: '0',
      width: '400px',
      background: 'white',
      border: '1px solid #ddd',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      zIndex: '1000',
      display: chatDropDown ? 'block' : 'none',
      maxHeight: '600px',
      overflow: 'hidden'
    },
    chatHeader: {
      padding: '15px',
      borderBottom: '1px solid #eee',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: '#3aaa43ff',
      color: 'white'
    },
    userItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '12px',
      cursor: 'pointer',
      transition: 'background 0.3s',
      borderBottom: '1px solid #f0f0f0',
      position: 'relative'
    },
    userAvatar: {
      width: '45px',
      height: '45px',
      borderRadius: '50%',
      overflow: 'hidden',
      marginRight: '12px',
      border: '2px solid #e0e0e0',
      flexShrink: 0
    },
    messageContent: {
      maxWidth: '75%',
      padding: '10px 15px',
      borderRadius: '15px',
      position: 'relative',
      wordWrap: 'break-word',
      marginBottom: '5px'
    },
    sentMessage: {
      background: '#007bff',
      color: 'white',
      borderBottomRightRadius: '5px'
    },
    receivedMessage: {
      background: '#f1f1f1',
      color: '#333',
      borderBottomLeftRadius: '5px'
    },
    messageInput: {
      padding: '15px',
      borderTop: '1px solid #eee',
      display: 'flex',
      gap: '10px',
      background: '#fff',
      alignItems: 'center'
    },
    badge: {
      position: 'absolute',
      top: '5px',
      right: '5px',
      background: '#ff4d4f',
      color: 'white',
      borderRadius: '50%',
      width: '18px',
      height: '18px',
      fontSize: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      border: '2px solid #fff'
    },
    notificationBox: {
      position: 'relative',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      padding: '10px 15px',
      transition: 'background 0.3s',
      borderRadius: '5px'
    },
    searchContainer: {
      padding: '10px 15px',
      borderBottom: '1px solid #eee',
      background: '#f8f9fa'
    },
    searchInput: {
      width: '100%',
      padding: '8px 12px',
      border: '1px solid #ddd',
      borderRadius: '20px',
      outline: 'none',
      fontSize: '14px'
    }
  };

  return (
    <Fragment>
      <style>
        {`
          .chat-dropdown-body {
            max-height: 450px;
            overflow-y: auto;
            background: #fff;
          }
          
          .chat-user-list {
            padding: 0;
          }
          
          .chat-user-item:hover {
            background: #f8f9fa;
          }
          
          .chat-user-item.active {
            background: #e3f2fd;
          }
          
          .chat-user-info {
            flex: 1;
            min-width: 0;
          }
          
          .chat-user-main {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 4px;
          }
          
          .chat-user-name {
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: #333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          
          .chat-user-role {
            margin: 0;
            font-size: 12px;
            color: #666;
            font-weight: 500;
          }
          
          .chat-last-message {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 4px;
          }
          
          .chat-message-preview {
            font-size: 12px;
            color: #666;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: 1;
            margin-right: 8px;
          }
          
          .chat-message-time {
            font-size: 11px;
            color: #999;
            white-space: nowrap;
          }
          
          .chat-unread-indicator {
            background: #007bff;
            color: white;
            border-radius: 50%;
            width: 8px;
            height: 8px;
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
          }
          
          .chat-messages-container {
            padding: 15px;
            max-height: 300px;
            overflow-y: auto;
            background: #fafafa;
            display: flex;
            flex-direction: column;
          }
          
          .chat-message {
            margin-bottom: 15px;
            display: flex;
            animation: fadeIn 0.3s ease-in;
          }
          
          .chat-message-sent {
            justify-content: flex-end;
          }
          
          .chat-message-received {
            justify-content: flex-start;
          }
          
          .chat-message-content p {
            margin: 0;
            font-size: 14px;
            line-height: 1.4;
          }
          
          .chat-message-datetime {
            font-size: 10px;
            opacity: 0.7;
            display: block;
            margin-top: 5px;
            text-align: right;
          }
          
          .chat-message-received .chat-message-datetime {
            text-align: left;
          }
          
          .chat-message-sender {
            font-size: 11px;
            font-weight: bold;
            margin-bottom: 2px;
            opacity: 0.8;
          }
          
          .chat-message-input input {
            flex: 1;
            padding: 8px 12px;
            border: 1px solid #ddd;
            border-radius: 20px;
            outline: none;
            font-size: 14px;
            transition: border-color 0.3s;
          }
          
          .chat-message-input input:focus {
            border-color: #007bff;
          }
          
          .chat-message-input button {
            background: #007bff;
            color: white;
            border: none;
            padding: 8px 15px;
            border-radius: 20px;
            cursor: pointer;
            font-size: 14px;
            transition: background 0.3s;
            display: flex;
            align-items: center;
            gap: 5px;
          }
          
          .chat-message-input button:hover {
            background: #0056b3;
          }
          
          .chat-message-input button:disabled {
            background: #ccc;
            cursor: not-allowed;
          }
          
          .chat-back-button {
            background: rgba(255,255,255,0.2);
            border: 1px solid rgba(255,255,255,0.3);
            color: white;
            cursor: pointer;
            font-size: 12px;
            padding: 5px 10px;
            border-radius: 15px;
            display: flex;
            align-items: center;
            gap: 5px;
            transition: background 0.3s;
          }
          
          .chat-back-button:hover {
            background: rgba(255,255,255,0.3);
          }
          
          .chat-loading {
            text-align: center;
            padding: 20px;
            color: #666;
          }
          
          .chat-loading-spinner {
            border: 2px solid #f3f3f3;
            border-top: 2px solid #007bff;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            animation: chatSpin 1s linear infinite;
            margin: 0 auto 10px;
          }
          
          .search-input-container {
            position: relative;
          }
          
          .search-clear-button {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            background: none;
            border: none;
            cursor: pointer;
            color: #999;
            font-size: 16px;
          }
          
          .search-clear-button:hover {
            color: #666;
          }
          
          .scroll-block-indicator {
            position: absolute;
            bottom: 10px;
            right: 10px;
            background: rgba(0,0,0,0.7);
            color: white;
            padding: 5px 10px;
            border-radius: 15px;
            font-size: 11px;
            z-index: 10;
            animation: fadeInOut 2s ease-in-out;
          }
          
          @keyframes chatSpin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          @keyframes fadeInOut {
            0%, 100% { opacity: 0; }
            50% { opacity: 1; }
          }
          
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
          
          .chat-no-users, .chat-no-messages {
            padding: 20px;
            text-align: center;
            color: #666;
          }
          
          .chat-no-conversation {
            padding: 20px;
            text-align: center;
            color: #999;
            font-style: italic;
          }
          
          .unread-user {
            background: #f0f8ff !important;
            border-left: 4px solid #007bff !important;
          }
          
          .unread-dot {
            animation: pulse 2s infinite;
            color: #007bff;
          }
          
          .dark-only .chat-dropdown-custom {
            background: #2f2f2f;
            border-color: #444;
          }
          
          .dark-only .chat-header-custom {
            background: #3f3f3f;
            border-color: #444;
            color: #fff;
          }
          
          .dark-only .chat-user-item:hover {
            background: #3f3f3f;
          }
          
          .dark-only .chat-user-name {
            color: #fff;
          }
          
          .dark-only .chat-user-role {
            color: #ccc;
          }
          
          .dark-only .chat-message-preview {
            color: #ccc;
          }
          
          .dark-only .chat-messages-container {
            background: #2a2a2a;
          }
          
          .dark-only .chat-message-received .chat-message-content-custom {
            background: #3f3f3f;
            color: #fff;
          }
          
          .dark-only .chat-message-input-custom {
            background: #2f2f2f;
            border-color: #444;
          }
          
          .dark-only .chat-message-input-custom input {
            background: #3f3f3f;
            border-color: #555;
            color: #fff;
          }
          
          .dark-only .search-container-custom {
            background: #3f3f3f;
            border-color: #444;
          }
          
          .dark-only .search-input-custom {
            background: #2f2f2f;
            border-color: #555;
            color: #fff;
          }
          
          /* Scrollbar personalizado */
          .chat-messages-container::-webkit-scrollbar {
            width: 6px;
          }
          
          .chat-messages-container::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
          }
          
          .chat-messages-container::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;
          }
          
          .chat-messages-container::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
          }
          
          .dark-only .chat-messages-container::-webkit-scrollbar-track {
            background: #3f3f3f;
          }
          
          .dark-only .chat-messages-container::-webkit-scrollbar-thumb {
            background: #666;
          }
          
          .dark-only .chat-messages-container::-webkit-scrollbar-thumb:hover {
            background: #888;
          }
        `}
      </style>

      <div className="nav-right col-8 pull-right right-header p-0">
        <ul className="nav-menus">
         
          <li><span className="header-search"><b>--Intranet--</b></span></li>
      
          {/* Icono de Chat */}
          <li className="onhover-dropdown">
            <div style={chatStyles.notificationBox} onClick={() => setChatDropDown(!chatDropDown)}>
              <MessageSquare />
              {/* Badge con el total de mensajes no leídos */}
              {totalUnread > 0 && (
                <span style={{
                  ...chatStyles.badge,
                  background: '#ff4d4f',
                  animation: totalUnread > 0 ? 'pulse 1.5s infinite' : 'none'
                }}>
                  {totalUnread > 99 ? '99+' : totalUnread}
                </span>
              )}
            </div>
            
            {/* Dropdown del Chat */}
            <div style={chatStyles.chatDropdown} className="chat-dropdown-custom">
              <div style={chatStyles.chatHeader} className="chat-header-custom">
                <h6>
                  {selectedUser ? `Chat con ${selectedUser.nombre}` : 'Mensajes'}
                  {totalUnread > 0 && !selectedUser && (
                    <span style={{
                      fontSize: '12px',
                      background: 'rgba(255,255,255,0.2)',
                      padding: '2px 8px',
                      borderRadius: '10px',
                      marginLeft: '8px'
                    }}>
                      {totalUnread} sin leer
                    </span>
                  )}
                </h6>
                <div className="chat-actions">
                  <span onClick={() => setChatDropDown(false)} style={{cursor: 'pointer', fontSize: '18px'}}>×</span>
                </div>
              </div>
              
              <div className="chat-dropdown-body" ref={chatBodyRef}>
                {!selectedUser ? (
                  /* Lista de usuarios con filtro de búsqueda */
                  <div>
                    {/* Barra de búsqueda */}
                    <div style={chatStyles.searchContainer} className="search-container-custom">
                      <div className="search-input-container">
                        <input
                          type="text"
                          placeholder="Buscar usuario..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          style={chatStyles.searchInput}
                          className="search-input-custom"
                        />
                        {searchTerm && (
                          <button className="search-clear-button" onClick={clearSearch}>
                            <X size={14} />
                          </button>
                        )}
                      </div>
                    </div>
                    
                    {/* Lista de usuarios */}
                    <div className="chat-user-list">
                      {loading ? (
                        <div className="chat-loading">
                          <div className="chat-loading-spinner"></div>
                          <p>Cargando conversaciones...</p>
                        </div>
                      ) : filteredUsers.length > 0 ? (
                        filteredUsers.map(user => {
                          const lastMessage = getLastMessageForUser(user.id);
                          const userUnreadCount = unreadByUser[user.id] || 0;
                          const hasUnread = userUnreadCount > 0;
                          
                          return (
                            <div 
                              key={user.id} 
                              style={{
                                ...chatStyles.userItem,
                                background: hasUnread ? '#f0f8ff' : 'transparent',
                                borderLeft: hasUnread ? '4px solid #007bff' : '4px solid transparent'
                              }}
                              className="chat-user-item"
                              onClick={() => openChat(user.id)}
                            >
                              <div style={chatStyles.userAvatar}>
                                <img src={man} alt={user.nombre} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                              </div>
                              <div className="chat-user-info">
                                <div className="chat-user-main">
                                  <div>
                                    <h6 className="chat-user-name">
                                      {user.nombre}
                                      {hasUnread && (
                                        <span className="unread-dot" style={{
                                          marginLeft: '5px',
                                          fontSize: '12px'
                                        }}>
                                          ●
                                        </span>
                                      )}
                                    </h6>
                                    <p className="chat-user-role">{user.cargo}</p>
                                  </div>
                                  <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                    {lastMessage && (
                                      <span className="chat-message-time">
                                        {formatLastMessageTime(lastMessage.fecha_registro)}
                                      </span>
                                    )}
                                    {userUnreadCount > 0 && (
                                      <span style={{
                                        background: '#007bff',
                                        color: 'white',
                                        borderRadius: '50%',
                                        width: '20px',
                                        height: '20px',
                                        fontSize: '10px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: 'bold',
                                        minWidth: '20px'
                                      }}>
                                        {userUnreadCount > 99 ? '99+' : userUnreadCount}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="chat-last-message">
                                  <p className="chat-message-preview" style={{
                                    color: hasUnread ? '#007bff' : '#666',
                                    fontWeight: hasUnread ? '600' : '400'
                                  }}>
                                    {getLastMessagePreview(lastMessage)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="chat-no-users">
                          <p>{searchTerm ? 'No se encontraron usuarios' : 'No hay usuarios disponibles'}</p>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  /* Área de mensajes */
                  <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <div style={chatStyles.chatHeader} className="chat-header-custom">
                      <button className="chat-back-button" onClick={backToUserList}>
                        <ArrowLeft size={14} />
                        Volver
                      </button>
                      <h6>Chat con {selectedUser.nombre}</h6>
                      <div style={{width: '70px'}}></div>
                    </div>
                    
                    <div 
                      className="chat-messages-container"
                      ref={messagesContainerRef}
                      onScroll={handleScroll}
                    >
                      {loading ? (
                        <div className="chat-loading">
                          <div className="chat-loading-spinner"></div>
                          <p>Cargando mensajes...</p>
                        </div>
                      ) : messages.length > 0 ? (
                        <>
                          {messages.map(message => {
                            const isSent = message.usuario_id === parseInt(getUserId());
                            const senderName = isSent ? 'Tú' : (message.usuario?.nombre || 'Usuario');
                            
                            return (
                              <div 
                                key={message.id} 
                                className={`chat-message ${isSent ? 'chat-message-sent' : 'chat-message-received'}`}
                              >
                                <div 
                                  style={{
                                    ...chatStyles.messageContent,
                                    ...(isSent ? chatStyles.sentMessage : chatStyles.receivedMessage)
                                  }}
                                  className="chat-message-content-custom"
                                >
                                  {!isSent && (
                                    <div className="chat-message-sender">{senderName}</div>
                                  )}
                                  <p>{message.descripcion}</p>
                                  <span className="chat-message-datetime">
                                    {formatMessageDateTime(message.fecha_registro)}
                                  </span>
                                </div>
                              </div>
                            );
                          })}
                          {isViewingHistory && (
                            <div className="scroll-block-indicator">
                              Nuevos mensajes disponibles
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="chat-no-messages">
                          <p>No hay mensajes aún</p>
                          <p>Envía el primer mensaje</p>
                        </div>
                      )}
                      <div ref={messagesEndRef} />
                    </div>
                    
                    <div style={chatStyles.messageInput} className="chat-message-input-custom">
                      <input
                        type="text"
                        placeholder="Escribe un mensaje..."
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
                      />
                      <button onClick={sendMessage} disabled={!newMessage.trim()}>
                        <Send size={14} />
                        Enviar
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </li>
          
          <li>
            <div className="mode" onClick={() => MoonlightToggle(moonlight)} >
              {moonlight ? <i className="fa fa-lightbulb-o"></i> : <i className="fa fa-moon-o"></i>}
            </div>
          </li>
        
          <li className="maximize"><a className="text-dark" style={{ color: 'white' }} href="#javascript" onClick={goFull}><Maximize /></a></li>
          
          <li className="profile-nav onhover-dropdown p-0">
            <div className="media profile-media">
              <img className="b-r-10" src={authenticated ? auth0_profile.picture : profile} alt="" />
              <div className="media-body"><span>{authenticated ? auth0_profile.name : name}</span>
                <p className="mb-0 font-roboto" style={{ color: 'white' }}>{Administrador} <i className="middle fa fa-angle-down"></i></p>
              </div>
            </div>
            <ul className="profile-dropdown onhover-show-div">
              <li onClick={() => UserMenuRedirect(`${process.env.PUBLIC_URL}/pages/perfil/${layout}`)}><User /><span>Mi cuenta</span></li>
              <li onClick={authenticated ? Logout_From_Auth0 : Logout_From_Firebase}><LogIn /><span>Salir</span></li>
            </ul>
          </li>
        </ul>
      </div>
    </Fragment>
  );
}

export default Rightbar;